// removed by extract-text-webpack-plugin
module.exports = {"button-bar":"_1RmBUDbNTThKOssw86RKLz","button-cancel":"_22_E97eS9PMStAi1mZ1vML","button-select":"_1C68rvXqQoPgTpIXJuu3DG"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressBook/components/AddressBookAdd/style.scss
// module id = 922
// module chunks = 0